
import { AfterViewInit, ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { WebhookEditNodeComponent } from "../webhook-edit-node/webhook-edit-node.component";
import { EFResizeHandleType } from "@foblex/flow";
import { NzModalService } from "ng-zorro-antd/modal";
import { LanguageServices } from "src/app/services/LanguageServices";



@Component({
    selector: 'webhook-edit-node-if',
    templateUrl: './webhook-edit-node-if.component.html',
    styleUrl: './webhook-edit-node-if.component.scss',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class WebhookEditNodeIfComponent extends WebhookEditNodeComponent implements AfterViewInit, OnInit {
    public eResizeHandleType =  EFResizeHandleType;
    constructor(protected ls:LanguageServices, protected modal:NzModalService) {
           super(ls,modal);
    }
    
    ngOnInit(): void {
        if (this.node.outputs != null ){
            this.trueOutput = this.node.outputs.filter(d=>d.includes("_out-right-true"));
            this.falseOutput = this.node.outputs.filter(d=>d.includes("_out-right-false"));

            
        }
    }

    trueOutput = [];
    falseOutput =  [];

    ngAfterViewInit(): void {
        
    }


}